// extracted by mini-css-extract-plugin
module.exports = {"read-more-read-less-wrapper":"styles_read-more-read-less-wrapper__2y35W"};